import { useEffect } from 'react';

const APP_NAME = 'JST';

type PageTitleProps = {
  title: string;
};

// React 19 hoists a rendered <title> to <head>, but it has no cleanup path
// for it: neither a prop change nor a keyed remount removes the old node,
// so two <title> elements end up coexisting. Setting document.title
// directly avoids that entirely and reuses the single <title> already in
// index.html; restoring the previous value on cleanup keeps navigation
// between pages correct without needing a context/registry.
export const PageTitle = ({ title }: PageTitleProps) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | ${APP_NAME}`;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return null;
};
